import { Helmet } from 'react-helmet';
import { useAuthStore } from '@olagg/store';

export const NR_TRACKER_BASE_URL = 'https://ht.newsroom.gg/?d=';

export const NrTracker = ({ id }: {id?: string}) => {
  const { me } = useAuthStore();

  if (!id) return null;

  const dataJSON = { 
    id: id,
    user: me?.id ?? ''
  };
  const dataString = encodeURIComponent(JSON.stringify(dataJSON));
  const urlNrScript = `${NR_TRACKER_BASE_URL}${dataString}`;

  return (
    <Helmet>
      <script src={urlNrScript} defer></script>
    </Helmet>
  )
}
